// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { muiGlobalTheme } from '@themes';
import { colors } from '../../css';

class CurrencyInput extends Component {
  static NumberFormatCustom = (props) => {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              value: values.value
            }
          });
        }}
        thousandSeparator
      />
    );
  };

  constructor(props) {
    super(props);
    muiGlobalTheme.palette.text.primary = '#000';
    muiGlobalTheme.palette.text.secondary = colors.colorGrey03;
    muiGlobalTheme.components.MuiIconButton = {
      styleOverrides: { root: { marginBottom: '10px' } }
    };

    this.inputTheme = createTheme(muiGlobalTheme);
  }

  render() {
    const { errorText, helperText, type, currency, ...defaultProps } = this.props;
    const { error, InputProps } = defaultProps;
    const curNight = `${currency}/night`;
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={this.inputTheme}>
          <TextField
            {...defaultProps}
            fullWidth
            helperText={error ? errorText : helperText}
            InputProps={{
              ...InputProps,
              endAdornment: <InputAdornment position="end">{curNight}</InputAdornment>,
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
              inputComponent: this.NumberFormatCustom
            }}
          />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

CurrencyInput.propTypes = {
  /**
   * Message that is displayed when the input has an error
   */
  errorText: PropTypes.string,
  /**
   * Optional helper text that sits below the input
   */
  helperText: PropTypes.string,
  type: PropTypes.string,
  currency: PropTypes.string
};

CurrencyInput.defaultProps = {
  errorText: 'Error',
  helperText: undefined,
  type: undefined,
  currency: undefined
};
export default CurrencyInput;
